var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],class:_vm.loadClass},[_c('div',{staticClass:"spinner-list"},[_c('div',{attrs:{"id":"flower"}},[_c('img',{attrs:{"src":_vm._f("bindCDNPath")(`assets/health/images/icn_loading.svg`)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }